import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let FightingStyles = class FightingStyles extends VuexModule {
    constructor() {
        super(...arguments);
        this.fightingStyles = [];
        this.cachedVersion = 0;
    }
    async fetchFightingStyles() {
        const { data: fightingStyles, cachedVersion } = await fetchFromCache(this, 'fightingStyles', 'fightingStyle');
        return { fightingStyles, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['fightingStyles', 'cachedVersion'] })
], FightingStyles.prototype, "fetchFightingStyles", null);
FightingStyles = __decorate([
    Module({ namespaced: true, name: 'fightingStyles' })
], FightingStyles);
export default FightingStyles;
